const PALETTE = [
  "#185EA9",
  "#6A1B9A",
  "#AD1457",
  "#00838F",
  "#33691E",
  "#E65100",
  "#4E342E",
  "#37474F",
  "#B71C1C",
  "#827717",
  "#00695C",
  "#1A237E",
];

export function colorFor(colorIndex) {
  if (colorIndex === null || colorIndex === undefined) {
    return PALETTE[0];
  }

  const normalizedIndex = ((colorIndex % PALETTE.length) + PALETTE.length) % PALETTE.length;
  return PALETTE[normalizedIndex];
}

export function contrastText(hex) {
  if (!hex) {
    return "#FFFFFF";
  }

  const normalized = hex.replace("#", "");
  const fullHex = normalized.length === 3
    ? normalized.split("").map((char) => char + char).join("")
    : normalized;

  const red = parseInt(fullHex.substring(0, 2), 16);
  const green = parseInt(fullHex.substring(2, 4), 16);
  const blue = parseInt(fullHex.substring(4, 6), 16);
  const luminance = ((red * 299) + (green * 587) + (blue * 114)) / 1000;

  return luminance >= 150 ? "#222222" : "#FFFFFF";
}

export function alphaColor(hex, alpha) {
  if (!hex) {
    return `rgba(24, 94, 169, ${alpha})`;
  }

  const normalized = hex.replace("#", "");
  const fullHex = normalized.length === 3
    ? normalized.split("").map((char) => char + char).join("")
    : normalized;

  const red = parseInt(fullHex.substring(0, 2), 16);
  const green = parseInt(fullHex.substring(2, 4), 16);
  const blue = parseInt(fullHex.substring(4, 6), 16);

  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

export function mixWithWhite(hex, whiteRatio = 0.5) {
  if (!hex) {
    return "#DDE8F5";
  }

  const normalized = hex.replace("#", "");
  const fullHex = normalized.length === 3
    ? normalized.split("").map((char) => char + char).join("")
    : normalized;

  const red = parseInt(fullHex.substring(0, 2), 16);
  const green = parseInt(fullHex.substring(2, 4), 16);
  const blue = parseInt(fullHex.substring(4, 6), 16);
  const ratio = Math.max(0, Math.min(1, whiteRatio));
  const mixedRed = Math.round((red * (1 - ratio)) + (255 * ratio));
  const mixedGreen = Math.round((green * (1 - ratio)) + (255 * ratio));
  const mixedBlue = Math.round((blue * (1 - ratio)) + (255 * ratio));

  return `rgb(${mixedRed}, ${mixedGreen}, ${mixedBlue})`;
}

export default PALETTE;
